import { SmartChargeSettingsModel } from 'src/Libs/smart-charge/models'
import { SmartChargeSettingsDto } from 'src/Libs/smart-charge/api'

const fromDtoToModelTransformer = (dto: SmartChargeSettingsDto): SmartChargeSettingsModel => ({
  emsBatteryBeforeCarMode: Boolean(dto.emsBatteryBeforeCarMode) || false,
  emsBatteryToCarMode: Boolean(dto.emsBatteryToCarMode) || false,
  emsWbDischargeBatUntil: Number(dto.emsWbDischargeBatUntil) || 0,
  emsWallboxEnforcePowerAssignment: Boolean(dto.emsWallboxEnforcePowerAssignment) || false,
  emsManualChargeActive: Boolean(dto.emsManualChargeActive) || false,
  emsManualChargeStartCounter: Number(dto.emsManualChargeStartCounter) || 0,
  emsManualChargeEnergyCounter: Number(dto.emsManualChargeEnergyCounter) || 0,
  emsManualChargeLastStart: Number(dto.emsManualChargeLaststart) || 0,
  emsSysSpec: dto.emsSysSpec || { maxChargePower: 0 },
  emsWeatherRegulatedChargeEnabled: Boolean(dto.emsWeatherRegulatedChargeEnabled) || false,
  emsWeatherForecastMode: Number(dto.emsWeatherForecastMode) || 0,
  weatherForecastActive: (dto.weatherForecastActive || []).map(item => ({ isActive: item.active, pmId: item.pmId })),
  weatherCalcMode: Boolean(dto.weatherCalcMode),
})

export default fromDtoToModelTransformer
